import { useEffect } from 'react';
import { analytics } from '../lib/firebase/config';
import { logEvent } from 'firebase/analytics';
import { useLocation } from 'react-router-dom';

export const useAnalytics = () => {
  const location = useLocation();

  // Track page views
  useEffect(() => {
    if (analytics) {
      logEvent(analytics, 'page_view', {
        page_path: location.pathname,
        page_title: document.title,
        page_location: window.location.href
      });
    }
  }, [location]);

  // Helper function to track events
  const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
    if (analytics) {
      // Add common parameters to all events
      const commonParams = {
        timestamp: Date.now(),
        path: location.pathname,
      };
      
      logEvent(analytics, eventName, {
        ...commonParams,
        ...eventParams
      });
      
      // Also log as custom event for more detailed tracking
      logEvent(analytics, 'custom_event', {
        ...commonParams,
        event_name: eventName,
        ...eventParams
      });
    }
  };

  // Helper function to track user engagement
  const trackEngagement = (action: string, params?: Record<string, any>) => {
    if (analytics) {
      logEvent(analytics, 'user_engagement', {
        engagement_action: action,
        timestamp: Date.now(),
        path: location.pathname,
        ...params
      });
    }
  };

  // Helper function to track feature usage
  const trackFeatureUsage = (feature: string, params?: Record<string, any>) => {
    if (analytics) {
      logEvent(analytics, 'feature_use', {
        feature_name: feature,
        timestamp: Date.now(),
        path: location.pathname,
        ...params
      });
    }
  };

  // Helper function to track errors
  const trackError = (error: Error, context?: string) => {
    if (analytics) {
      logEvent(analytics, 'error', {
        error_name: error.name,
        error_message: error.message,
        error_stack: error.stack,
        error_context: context,
        timestamp: Date.now(),
        path: location.pathname
      });
    }
  };

  return { 
    trackEvent,
    trackEngagement,
    trackFeatureUsage,
    trackError
  };
}; 